import { render, staticRenderFns } from "./AssignZone.vue?vue&type=template&id=70764500"
import script from "./AssignZone.vue?vue&type=script&lang=js"
export * from "./AssignZone.vue?vue&type=script&lang=js"
import style0 from "./AssignZone.vue?vue&type=style&index=0&id=70764500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports